import { Box, Button } from "@mui/material";

const TabPills = ({ tabIndex, setTabIndex }: any) => {
  return (
    <Box
      m={2}
      py={1}
      sx={{
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
        backgroundColor: "#F4F4F4",
      }}
    >
      <Button
        onClick={() => setTabIndex(1)}
        size="small"
        variant={tabIndex == 1 ? "contained" : "text"}
        sx={{ color: tabIndex == 1 ? "#fff" : "#A2A2A2" }}
      >
        Owner
      </Button>
      <Button
        onClick={() => setTabIndex(2)}
        size="small"
        variant={tabIndex == 2 ? "contained" : "text"}
        sx={{ color: tabIndex == 2 ? "#fff" : "#A2A2A2" }}
      >
        Rental
      </Button>
    </Box>
  );
};

export default TabPills;
